/**
 * Tenant Portal Main Layout
 * =========================
 * التخطيط الرئيسي لبوابة الشركات
 */

import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useTenantAuth } from '../context/TenantAuthContext';
import './TenantLayout.css';

// Inline SVG Icons
const Icons = {
  dashboard: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="9" rx="1"/><rect x="14" y="3" width="7" height="5" rx="1"/><rect x="14" y="12" width="7" height="9" rx="1"/><rect x="3" y="16" width="7" height="5" rx="1"/></svg>,
  employees: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  drivers: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4"/></svg>,
  applications: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>,
  ships: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 20h20M4 20V10l8-6 8 6v10"/><path d="M9 20v-6h6v6"/></svg>,
  vehicles: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a1 1 0 0 0-.8-.4H5.24a2 2 0 0 0-1.8 1.1l-.8 1.63A6 6 0 0 0 2 12.42V16h2"/><circle cx="6.5" cy="16.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/></svg>,
  shifts: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  orders: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12h6M9 16h6"/></svg>,
  support: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  promotions: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>,
  media: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>,
  reports: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 20V10M12 20V4M6 20v-6"/></svg>,
  pricing: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="8" y1="10" x2="10" y2="10"/><line x1="14" y1="10" x2="16" y2="10"/><line x1="8" y1="14" x2="10" y2="14"/><line x1="14" y1="14" x2="16" y2="14"/><line x1="8" y1="18" x2="16" y2="18"/></svg>,
  settings: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  logout: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  menu: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>,
  bell: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
};

const navItems = [
  { path: '/tenant/dashboard', label: 'لوحة المعلومات', icon: 'dashboard' },
  { path: '/tenant/orders', label: 'الطلبات', icon: 'orders' },
  { path: '/tenant/drivers', label: 'السواقين', icon: 'drivers' },
  { path: '/tenant/drivers/applications', label: 'طلبات الانضمام', icon: 'applications' },
  { path: '/tenant/vehicles', label: 'المركبات', icon: 'vehicles' },
  { path: '/tenant/ships', label: 'الأشياب', icon: 'ships' },
  { path: '/tenant/shifts', label: 'الورديات', icon: 'shifts' },
  { path: '/tenant/employees', label: 'الموظفين', icon: 'employees' },
  { path: '/tenant/support', label: 'الدعم الفني', icon: 'support' },
  { path: '/tenant/promotions', label: 'العروض والكوبونات', icon: 'promotions' },
  { path: '/tenant/media', label: 'المحتوى والوسائط', icon: 'media' },
  { path: '/tenant/reports', label: 'التقارير', icon: 'reports' },
  { path: '/tenant/pricing', label: 'التسعير', icon: 'pricing' },
  { path: '/tenant/settings', label: 'الإعدادات', icon: 'settings' },
];

const TenantLayout = () => {
  const { user, tenant, logout } = useTenantAuth();
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/tenant/login');
  };

  return (
    <div className={`tenant-layout ${sidebarCollapsed ? 'tenant-layout--collapsed' : ''}`}>
      {/* Sidebar */}
      <aside className={`tenant-sidebar ${mobileMenuOpen ? 'tenant-sidebar--open' : ''}`}>
        <div className="tenant-sidebar__header">
          {tenant?.logo_url ? (
            <img src={tenant.logo_url} alt={tenant.name} className="tenant-sidebar__logo" />
          ) : (
            <div className="tenant-sidebar__logo-placeholder">
              {tenant?.name?.charAt(0) || 'W'}
            </div>
          )}
          {!sidebarCollapsed && (
            <div className="tenant-sidebar__brand">
              <span className="tenant-sidebar__brand-name">{tenant?.name || 'شركتي'}</span>
              <span className="tenant-sidebar__brand-plan">{tenant?.subscription_plan || 'أساسي'}</span>
            </div>
          )}
        </div>

        <nav className="tenant-sidebar__nav">
          {navItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => 
                `tenant-sidebar__link ${isActive ? 'tenant-sidebar__link--active' : ''}`
              }
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="tenant-sidebar__link-icon">{Icons[item.icon]}</span>
              {!sidebarCollapsed && <span className="tenant-sidebar__link-label">{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <div className="tenant-sidebar__footer">
          <button className="tenant-sidebar__logout" onClick={handleLogout}>
            <span className="tenant-sidebar__link-icon">{Icons.logout}</span>
            {!sidebarCollapsed && <span>تسجيل الخروج</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="tenant-main">
        {/* Header */}
        <header className="tenant-header">
          <button 
            className="tenant-header__menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {Icons.menu}
          </button>

          <button 
            className="tenant-header__collapse-btn"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          >
            {Icons.menu}
          </button>

          <div className="tenant-header__spacer" />

          <button className="tenant-header__notifications">
            {Icons.bell}
            <span className="tenant-header__notifications-badge">3</span>
          </button>

          <div className="tenant-header__user">
            <div className="tenant-header__user-avatar">
              {user?.avatar_url ? (
                <img src={user.avatar_url} alt={user.full_name} />
              ) : (
                <span>{user?.full_name?.charAt(0) || 'U'}</span>
              )}
            </div>
            <div className="tenant-header__user-info">
              <span className="tenant-header__user-name">{user?.full_name || 'مستخدم'}</span>
              <span className="tenant-header__user-role">{user?.roles?.[0] || 'موظف'}</span>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <div className="tenant-content">
          <Outlet />
        </div>
      </main>

      {/* Mobile Overlay */}
      {mobileMenuOpen && (
        <div 
          className="tenant-overlay"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}
    </div>
  );
};

export default TenantLayout;
